export default "__VITE_ASSET__BYHRyOYN__"